import { LayoutGridIconNew, LayoutListIconNew } from '../assets/icons';

export const layoutData = [
  {
    text: 'Poll_PollSettings_Tab_Layout_Section_Answers_Layout_Grid',
    commandKey: 'GRID',
    icon: LayoutGridIconNew,
    dataHook: 'poll_grid',
  },
  {
    text: 'Poll_PollSettings_Tab_Layout_Section_Answers_Layout_List',
    commandKey: 'LIST',
    icon: LayoutListIconNew,
    dataHook: 'poll_list',
  },
];
